export const AgentEnum = {
    TopAgent: 1,
    Agent: 2,
    Player: 3
}